export default __webpack_public_path__ + "static/caixa1-f68e35233fa9994e80aa2c07c1d5b02c.webp";